<template>
  <v-dialog
    v-model="dialog"
    width="600px"
    style="z-index: 9999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.contact.title") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn @click="updateEvent" elevation="0" color="primary">
          {{ $t("dialog.contact.store") }}
        </v-btn>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-container class="pb-6">
        <validation-observer ref="form_validation">
          <form @submit.prevent="submit">
            <v-row>
              <v-col class="my-0 py-0 mt-2">
                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.contact.type"
                  rules="required"
                >
                  <v-select
                    v-model="type"
                    :items="getContactTypes"
                    :label="$t('dialog.contact.type')"
                    :error-messages="errors"
                    clearable
                  >
                    <template v-slot:selection="data">
                      {{ $t("enum.contact_type." + data.item) }}
                    </template>
                    <template v-slot:item="data">
                      {{ $t("enum.contact_type." + data.item) }}
                    </template>
                  </v-select>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row v-if="type === 'phone'">
              <v-col class="my-0 py-0">
                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.contact.phone"
                  rules="required|phone"
                >
                  <v-text-field
                    v-model="phone"
                    :error-messages="errors"
                    :label="$t('dialog.contact.phone')"
                    clearable
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row v-else-if="type === 'email'">
              <v-col class="my-0 py-0">
                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.contact.email"
                  rules="required|email"
                >
                  <v-text-field
                    v-model="email"
                    :error-messages="errors"
                    :label="$t('dialog.contact.email')"
                    clearable
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <template v-if="type === 'address'">
              <v-row>
                <v-col class="my-0 py-0" cols="8">
                  <validation-provider
                    v-slot="{ errors }"
                    name="dialog.contact.street"
                    rules=""
                  >
                    <v-text-field
                      v-model="road"
                      :error-messages="errors"
                      :label="$t('dialog.contact.street')"
                      clearable
                    ></v-text-field>
                  </validation-provider>
                </v-col>

                <v-col class="my-0 py-0" cols="4">
                  <validation-provider
                    v-slot="{ errors }"
                    name="dialog.contact.house_number"
                    rules="required"
                  >
                    <v-text-field
                      v-model="houseNumber"
                      :error-messages="errors"
                      :label="$t('dialog.contact.house_number')"
                      clearable
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="my-0 py-0" cols="8">
                  <validation-provider
                    v-slot="{ errors }"
                    name="dialog.contact.city"
                    rules="required"
                  >
                    <v-text-field
                      v-model="city"
                      :error-messages="errors"
                      :label="$t('dialog.contact.city')"
                      clearable
                    ></v-text-field>
                  </validation-provider>
                </v-col>

                <v-col class="my-0 py-0" cols="4">
                  <validation-provider
                    v-slot="{ errors }"
                    name="dialog.contact.postal_code"
                    rules="required"
                  >
                    <v-text-field
                      v-model="postcode"
                      :error-messages="errors"
                      :label="$t('dialog.contact.postal_code')"
                      clearable
                    ></v-text-field>
                  </validation-provider>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="my-0 py-0">
                  <CountryField
                    v-model="countryCode"
                    :label="$t('dialog.contact.country')"
                    required
                    clearable />
                </v-col>
              </v-row>
            </template>

            <v-row>
              <v-col class="my-0 py-0">
                <validation-provider
                  v-slot="{ errors }"
                  name="dialog.contact.note"
                  rules="max:50"
                >
                  <v-text-field
                    v-model="note"
                    :error-messages="errors"
                    :label="$t('dialog.contact.note')"
                    clearable
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="my-0 py-0 mt-2">
                <v-checkbox class="my-0 py-0"
                            v-model="registered"
                            :value="registered"
                            :label="$t('dialog.contact.registered')"
                            type="checkbox"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="my-0 py-0">
                <v-checkbox class="my-0 py-0"
                            v-model="billing"
                            :value="billing"
                            :label="$t('dialog.contact.billing')"
                            type="checkbox"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="my-0 py-0">
                <v-checkbox class="my-0 py-0"
                            v-model="communication"
                            :value="communication"
                            :label="$t('dialog.contact.communication')"
                            type="checkbox"
                ></v-checkbox>
              </v-col>
            </v-row>

          </form>
        </validation-observer>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import CountryField from "@/components/fields/CountryField.vue";

export default {
  name: "ContactDialog",
  components: { CountryField },

  data() {
    return {
      dialog: false,
      contact: null,

      contactId: null,
      type: null,
      registered: false,
      billing: false,
      communication: false,
      note: null,

      phone: null,
      email: null,
      address: null,
      road: null,
      houseNumber: null,
      postcode: null,
      city: null,
      countryCode: null
    };
  },

  methods: {
    open(contact) {
      this.phone = null;
      this.email = null;
      this.road = null;
      this.houseNumber = null;
      this.zip = null;
      this.city = null;
      this.countryCode = null;

      this.contact = contact;
      this.contactId = contact.contactId;
      this.type = (contact.type === null || this.type === undefined) ? "phone" : contact.type;
      this.registered = contact.registered;
      this.billing = contact.billing;
      this.communication = contact.communication;
      this.note = contact.note;

      if (this.type === "phone")
        this.phone = contact.contactValue;
      else if (this.type === "email")
        this.email = contact.contactValue;
      else if (this.type === "address") {
        if (contact.contactValue != null) {
          this.road = contact.contactValue.road || null;
          this.houseNumber = contact.contactValue.houseNumber || null;
          this.city = contact.contactValue.city || null;
          this.postcode = contact.contactValue.postcode || null;
          this.countryCode = contact.contactValue.countryCode || null;
        }
      }

      this.dialog = true;

      if (this.$refs.form_validation !== undefined)
        this.$refs.form_validation.reset();
    },

    async updateEvent() {
      if (await this.$refs.form_validation.validate()) {

        this.contact.type = this.type;
        this.contact.registered = this.registered;
        this.contact.billing = this.billing;
        this.contact.communication = this.communication;
        this.contact.note = this.note;

        if (this.type === "phone")
          this.contact.contactValue = this.phone;
        else if (this.type === "email")
          this.contact.contactValue = this.email;
        else if (this.type === "address") {
          this.contact.contactValue = {
            road: this.road,
            houseNumber: this.houseNumber,
            city: this.city,
            postcode: this.postcode,
            countryCode: this.countryCode
          };
        }

        this.$emit("updated", this.contact);
        this.dialog = false;
      }
    },

    removeEvent() {
      this.$emit("updated", { contactId: this.contactId });
      this.dialog = false;
    }
  },

  computed: {
    getContactTypes() {
      return ["phone", "email", "address"];
    }
  },

  mounted() {
  }
};
</script>